import toArray from 'lodash/toArray';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import forEach from 'lodash/forEach';

function validateLabMediaNodes(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
  const labAssets = caseConf._labAssets || [];
  const labAssetsById = keyBy(labAssets, 'key');
  const errors = [];
  const warnings = [];

  // Checks
  const checkNodes = nodes.filter((node) => node.name === 'Check');

  checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if (check.type !== 'LAB_ASSET_VIEWED') return;
      const mediaId = get(check, 'id');
      const mediaUrl = get(check, 'url');
      let message;      
      if (mediaId && mediaUrl) {
        const {assets} = labAssetsById[mediaId].options;
        if (!assets.find(asset => asset.url === mediaUrl)) {
          message = 'Media is missing';
        }
      } else {
        message = 'Media not selected';
      }
      if (message) {
        errors.push({
          message,
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: node.id,
          metadata: {
            nodeId: node.id,
            mediaUrl: mediaUrl,
            checkKey
          },
        });
      }
    });
  });


  // Effects
  const labMediaEffectNodes = nodes.filter(
    (node) => node.name === 'Effect' && get(node, 'data.effect.type') === 'LAB_ASSET_AVAILABLE',
  );
  labMediaEffectNodes.forEach((mediaEffectNode) => {
    const mediaId = get(mediaEffectNode, 'data.effect.id');
    const mediaUrl = get(mediaEffectNode, 'data.effect.url');
    if (mediaId && mediaUrl) {
      const {assets} = labAssetsById[mediaId].options;
      if (!assets.find(asset => asset.url === mediaUrl)) {
        errors.push({
          message: 'Media is missing',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: mediaEffectNode.id,
          metadata: {
            nodeId: mediaEffectNode.id,
            mediaUrl: mediaEffectNode.data.effect.url,
          },
        });
      }
    }
  });
  return {
    errors,
    warnings,
  };
}

export default validateLabMediaNodes;
